import { ApiResult, request, safeRequest } from '@synergy/api';
import { Canceler } from 'axios';

import { DocumentPatchRequest } from './models/document-patch.request';
import { SupplierDocument } from '../models/supplier-detail-document';

export class SupplierDocumentsApi {
    constructor(protected baseUrl: string) {}

    public getDocuments(supplierId: number): Promise<ApiResult<SupplierDocument[]>> {
        return safeRequest(
            () => request.get<{ documents: SupplierDocument[] }>(`${this.baseUrl}/suppliers/${supplierId}/documents`),
            response => response.data.documents
        );
    }

    public addDocument(
        supplierId: number,
        file: File,
        cancelFunction?: (canceler: Canceler) => void,
        progressCallback?: (progress: ProgressEvent) => void
    ): Promise<ApiResult<SupplierDocument>> {
        return safeRequest(
            () => {
                const data = new FormData();
                data.append('file', file, file.name);

                const config = {
                    headers: { 'content-type': 'multipart/form-data' },
                    onUploadProgress: progressCallback,
                    cancelToken: cancelFunction && new request.CancelToken(cancelFunction),
                };

                return request.post(`${this.baseUrl}/suppliers/${supplierId}/documents/upload`, data, config);
            },
            response => response.data
        );
    }

    public updateDocument(supplierId: number, patch: DocumentPatchRequest): Promise<ApiResult<SupplierDocument>> {
        return safeRequest(
            () =>
                request.patch(`${this.baseUrl}/suppliers/${supplierId}/documents/${patch.id}`, {
                    title: patch.title,
                    isVisibleOnProductPages: patch.isVisibleOnProductPages,
                    isVisibleInSupplierDirectory: patch.isVisibleInSupplierDirectory,
                }),
            response => response.data
        );
    }

    public deleteDocument(supplierId: number, documentId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/suppliers/${supplierId}/documents/${documentId}`),
            response => response.data
        );
    }
}
